/**
 * Which school an analytics screen is about, for the person viewing it.
 *
 * A principal's school is the one they manage; everyone else's is their own.
 * Admins and super admins have no school, so they name one in the URL — and
 * only they may, so a teacher cannot point a screen at another school by
 * editing the address (the rules would refuse the read anyway).
 */
export function viewerSchoolId(
  profile: { role?: string; school_id?: string | null; managed_school_id?: string | null } | null,
  requested?: string | null
): string | null {
  if (!profile) return null;
  if (profile.role === 'admin' || profile.role === 'superadmin') return requested || profile.school_id || null;
  if (profile.role === 'principal') return profile.managed_school_id || profile.school_id || null;
  return profile.school_id || null;
}
